module.exports = __webpack_public_path__ + "static/media/logoo.54b429ad.png";